import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  //timeout: 30000,
    //timeout: 180000, // 3 minutes = 180,000 ms(milliseconds)
    timeout: 60000, // 1 minutes = 60,000 ms(milliseconds)
  headers: { 'Content-Type': 'application/json' },
});

// Request interceptor - attach JWT token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('sendero_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle 401
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('sendero_token');
      localStorage.removeItem('sendero_provider_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const isApiConfigured = () => !!API_BASE_URL;

export default apiClient;
